/* Generated by scripts/build_gift_theme_assets.mjs. Do not hand-edit. */
(function () {
  function initCarousel(root) {
    if (root.dataset.apgNativeReady === 'true') return;
    root.dataset.apgNativeReady = 'true';
    var track = root.querySelector('[data-apg-track]');
    var previous = root.querySelector('[data-apg-prev]');
    var next = root.querySelector('[data-apg-next]');
    if (!track || !previous || !next) return;
    function update() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      previous.disabled = track.scrollLeft <= 8;
      next.disabled = track.scrollLeft >= max;
    }
    function step(direction) {
      var card = track.querySelector('.apg-scard');
      var width = card ? card.getBoundingClientRect().width + 18 : 318;
      track.scrollBy({ left: direction * width, behavior: 'smooth' });
    }
    previous.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
    window.setTimeout(update, 100);
  }

  document.querySelectorAll('[data-apg-carousel]').forEach(initCarousel);

  document.querySelectorAll('.apg-gift-page .apg-faq__item').forEach(function (item) {
    var summary = item.querySelector('summary');
    if (!summary) return;
    summary.addEventListener('click', function (event) {
      if (!item.open) return;
      event.preventDefault();
      if (item.classList.contains('is-closing')) return;
      item.classList.add('is-closing');
      setTimeout(function () {
        item.open = false;
        item.classList.remove('is-closing');
      }, 340);
    });
  });
})();

(function () {
  var SCOPE = "apg-gift-page";
  var root = document.querySelector('.' + SCOPE);
  if (!root) return;
  var holder = document.querySelector('script[data-apg-gift-config="' + SCOPE + '"]');
  if (!holder) return;
  var cfg;
  try { cfg = JSON.parse(holder.textContent); } catch (e) { return; }

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var IO = window.IntersectionObserver;
  root.classList.add('apg-gift-js');

  var pathLeaf = location.pathname.split('/').filter(Boolean).pop() || '';
  var pageSlug = (location.pathname.match(/^\/pages\/([^/?#]+)/) || [])[1]
    || (pathLeaf.slice(-5) === '.html' ? pathLeaf.slice(0, -5) : pathLeaf);
  function giftEvent(name, detail) {
    try {
      if (navigator.webdriver === true || /(bot|crawler|spider|headlesschrome|lighthouse|pagespeed|playwright|puppeteer)/i.test(navigator.userAgent || '')) return;
      var payload = Object.assign({
        page: location.pathname,
        page_slug: pageSlug,
        gift_scope: root.className.split(/\s+/).filter(function (name) {
          return name.indexOf('apg-gift-') === 0 && name !== 'apg-gift-page' && name !== 'apg-gift-js';
        })[0] || '',
        device: window.innerWidth <= 767 ? 'mobile' : 'desktop'
      }, detail || {});
      if (typeof window.__APEvent === 'function') window.__APEvent(name, payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) { /* measurement must never interrupt shopping */ }
  }

  root.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var heroAction = target.closest('.apg-hero__cta .apg-btn');
    if (heroAction && root.contains(heroAction)) {
      var heroHref = heroAction.getAttribute('href') || '';
      var heroActions = [].slice.call(root.querySelectorAll('.apg-hero__cta .apg-btn'));
      giftEvent('gift_guide_hero_clicked', {
        action_rank: heroActions.indexOf(heroAction) + 1,
        action_label: (heroAction.textContent || '').trim(),
        destination: heroHref,
        path_type: /(finder|gift-aid)/.test(heroHref) ? 'assisted' : 'direct'
      });
    }
    var quickAdd = target.closest('[data-apg-quick-add-button]');
    if (quickAdd && root.contains(quickAdd)) {
      var form = quickAdd.closest('[data-apg-quick-add]');
      var shell = quickAdd.closest('.apg-scard-shell');
      var card = shell ? shell.querySelector('.apg-scard[data-apg-handle]') : quickAdd.closest('.apg-scard[data-apg-handle]');
      var quickRail = card && card.closest('.apg-shop[data-apg-carousel]');
      var selected = form && (form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]'));
      giftEvent('gift_guide_quick_add_clicked', {
        product_handle: card ? card.getAttribute('data-apg-handle') || '' : '',
        variant_id: selected ? selected.value || '' : '',
        rail_id: quickRail ? quickRail.getAttribute('data-apg-carousel') || '' : ''
      });
      return;
    }
    var bundle = target.closest('.apg-bb__cta, a[href*="/pages/build-your-waterless-oil-bundle"], a[href*="/pages/build-your-waterless-scent-bundle"]');
    if (bundle && root.contains(bundle)) {
      var bundleHref = bundle.getAttribute('href') || '';
      giftEvent('gift_guide_bundle_clicked', {
        bundle_type: bundleHref.indexOf('/pages/build-your-waterless-oil-bundle') !== -1 ? 'three_oil' : 'diffuser_and_scents',
        destination: bundleHref
      });
      return;
    }
    var result = target.closest('.apg-gift-res__link');
    if (result && root.contains(result)) {
      giftEvent('gift_guide_finder_result_clicked', {
        product_handle: (result.getAttribute('href') || '').split('/products/')[1] || '',
        result_rank: Number(result.getAttribute('data-apg-result-rank') || 0)
      });
    }
    var productCard = target.closest('a.apg-scard[data-apg-handle]');
    if (productCard && root.contains(productCard)) {
      var productRail = productCard.closest('.apg-shop[data-apg-carousel]');
      var railCards = productRail ? [].slice.call(productRail.querySelectorAll('a.apg-scard[data-apg-handle]')) : [];
      giftEvent('gift_guide_product_clicked', {
        product_handle: productCard.getAttribute('data-apg-handle') || '',
        rail_id: productRail ? productRail.getAttribute('data-apg-carousel') || '' : '',
        product_rank: railCards.indexOf(productCard) + 1,
        destination: productCard.getAttribute('href') || ''
      });
    }
  });

  [].slice.call(root.querySelectorAll('.apg-faq__item')).forEach(function (item, index) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      var question = item.querySelector('summary h3');
      giftEvent('gift_guide_faq_opened', {
        question_rank: index + 1,
        question: question ? (question.textContent || '').trim() : ''
      });
    });
  });

  [].slice.call(root.querySelectorAll('[data-apg-quick-add]')).forEach(function (form) {
    var button = form.querySelector('[data-apg-quick-add-button]');
    if (!button) return;
    function syncQuickAdd() {
      var selected = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!selected) return;
      var label = selected.getAttribute('data-apg-add-label') || 'Add to cart';
      if (button.hasAttribute('data-apg-icon-button')) button.setAttribute('aria-label', label);
      else button.textContent = label;
      var price = form.querySelector('[data-apg-card-price]');
      if (price) price.textContent = selected.getAttribute('data-apg-price-label') || price.textContent;
    }
    form.addEventListener('change', syncQuickAdd);
    syncQuickAdd();
  });

  var specMore = root.querySelector('[data-apg-spec-more]');
  if (specMore) {
    var specMoreClosed = specMore.textContent;
    specMore.addEventListener('click', function () {
      var open = root.classList.toggle('apg-gift-spec-expanded');
      specMore.setAttribute('aria-expanded', open ? 'true' : 'false');
      specMore.textContent = open ? 'Show the recommended 3' : specMoreClosed;
    });
  }

  var ICON_PLUS = '<svg class="apg-ic" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
  var ICON_TICK = '<svg class="apg-ic" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M4 12.5l5 5 11-11" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  var ICON_X = '<svg class="apg-ic" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
  var ICON_ARROW = '<svg class="apg-ic" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function boxOf(card) {
    var p = card.parentNode;
    if (p && p.classList && p.classList.contains('apg-scard-shell')) {
      var outer = p.parentNode;
      return (outer && outer.classList && outer.classList.contains('apg-gift-pick')) ? outer : p;
    }
    return (p && p.classList && p.classList.contains('apg-gift-pick')) ? p : card;
  }
  function cardsIn(railId) {
    var panel = document.getElementById(railId);
    return panel ? [].slice.call(panel.querySelectorAll('.apg-scard[data-apg-handle]')) : [];
  }

  /* ------------------------------------------------------------- reveals */

  /** Re-run the entrance on a node that has just come back from hidden. */
  function restage(node, delay) {
    if (reduce) return;
    node.style.transition = 'none';
    node.style.translate = '0 12px';
    void node.offsetWidth;
    node.style.transition = '';
    node.style.setProperty('--apg-d', delay + 'ms');
    requestAnimationFrame(function () { node.style.translate = ''; });
  }

  function armReveal(items) {
    if (reduce || !IO || !items.length) return;
    items.forEach(function (it) { it.setAttribute('data-apg-reveal', ''); });
    var io = new IO(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = Number(e.target.getAttribute('data-apg-i') || 0);
        e.target.style.setProperty('--apg-d', (i * 65) + 'ms');
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    items.forEach(function (it, i) {
      it.setAttribute('data-apg-i', String(i % 8));
      io.observe(it);
    });
  }

  /** One orchestrated hero entrance, not six scattered ones. */
  function heroEntrance() {
    if (reduce) return;
    var hero = root.querySelector('.apg-gift-hero') || root;
    var seq = ['.apg-hero__meta', '.apg-hero__title', '.apg-hero__rule', '.apg-hero__lede', '.apg-hero__cta', '.apg-hero__note', '.apg-gift-hero__art'];
    var nodes = [];
    seq.forEach(function (sel) {
      var n = hero.querySelector(sel);
      if (n) nodes.push(n);
    });
    nodes.forEach(function (n) { n.setAttribute('data-apg-reveal', ''); });
    requestAnimationFrame(function () {
      nodes.forEach(function (n, i) {
        n.style.setProperty('--apg-d', (i * 80) + 'ms');
        n.classList.add('is-in');
      });
    });
  }

  /* ------------------------------------------------- rail filters (1 + 2) */

  function buildFilter(rail) {
    if (!rail.filter || !rail.options || rail.options.length < 2) return;
    var panel = document.getElementById(rail.id);
    if (!panel) return;
    var inner = panel.querySelector('.apg-shop__inner');
    var track = panel.querySelector('[data-apg-track]');
    var cards = cardsIn(rail.id);
    if (!inner || !track || !cards.length) return;

    var attr = rail.filter === 'scent'
      ? 'data-apg-family'
      : rail.filter === 'scent-path' ? 'data-apg-scent-paths' : 'data-apg-band';
    var bar = el('div', 'apg-gift-filter apg-gift-filter--' + rail.filter);
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', rail.filterLabel);
    bar.appendChild(el('span', 'apg-gift-filter__lab', rail.filterLabel));
    if (rail.filter === 'scent-path') bar.appendChild(el('span', 'apg-gift-filter__hint', 'Swipe to explore →'));

    var list = el('div', 'apg-gift-filter__set');
    var initial = rail.defaultFilter || 'all';
    var allOption = rail.filter === 'scent-path'
      ? { id: 'all', label: 'All options', description: 'Every waterless oil', count: cards.length }
      : { id: 'all', label: 'All', count: cards.length };
    var opts = [allOption].concat(rail.options);
    if (initial !== 'all') {
      var initialAt = opts.findIndex(function (o) { return o.id === initial; });
      if (initialAt > 0) opts.unshift(opts.splice(initialAt, 1)[0]);
    }
    var buttons = [];

    opts.forEach(function (o) {
      var b = el('button', 'apg-gift-chip');
      b.type = 'button';
      b.setAttribute('data-v', o.id);
      b.setAttribute('aria-pressed', o.id === initial ? 'true' : 'false');
      var head = el('span', 'apg-gift-chip__head');
      head.appendChild(el('span', 'apg-gift-chip__t', o.label));
      head.appendChild(el('span', 'apg-gift-chip__n', String(o.count)));
      b.appendChild(head);
      if (o.description) b.appendChild(el('span', 'apg-gift-chip__desc', o.description));
      b.addEventListener('click', function () { apply(o.id, true); });
      list.appendChild(b);
      buttons.push(b);
    });

    var live = el('p', 'apg-gift-filter__live');
    live.setAttribute('aria-live', 'polite');
    live.textContent = cards.length + ' of ' + cards.length + ' shown';

    bar.appendChild(list);
    bar.appendChild(live);
    inner.insertBefore(bar, panel.querySelector('.apg-carousel'));

    function apply(v, userInitiated) {
      var shown = 0;
      cards.forEach(function (c) {
        var values = (c.getAttribute(attr) || '').split(' ');
        var ok = v === 'all' || values.indexOf(v) > -1;
        var box = boxOf(c);
        box.hidden = !ok;
        if (ok) { restage(box, Math.min(shown, 9) * 45); shown += 1; }
      });
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-v') === v ? 'true' : 'false');
      });
      track.scrollLeft = 0;
      live.textContent = shown + ' of ' + cards.length + ' shown';
      track.dispatchEvent(new Event('scroll'));
      if (userInitiated) giftEvent('gift_guide_filter_selected', {
        rail_id: rail.id,
        filter_type: rail.filter,
        filter_value: v,
        products_shown: shown,
        products_total: cards.length
      });
    }
    apply(initial);
  }

  /* ------------------------------------------------------- compare bar (3) */

  function buildCompare(rail) {
    if (!rail.compare) return;
    var cards = cardsIn(rail.id);
    if (cards.length < 2) return;
    var MAX = 3;
    var picked = [];
    var bar = null;
    var dismissed = false;

    cards.forEach(function (card) {
      var cardBox = card.parentNode && card.parentNode.classList && card.parentNode.classList.contains('apg-scard-shell')
        ? card.parentNode : card;
      var wrap = el('div', 'apg-gift-pick');
      wrap.setAttribute('role', 'listitem');
      cardBox.removeAttribute('role');
      cardBox.parentNode.insertBefore(wrap, cardBox);
      wrap.appendChild(cardBox);
      var name = nameOf(card);
      var b = el('button', 'apg-gift-cmpbtn');
      b.type = 'button';
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', 'Add ' + name + ' to the comparison');
      b.innerHTML = ICON_PLUS;
      b.appendChild(el('span', 'apg-gift-cmpbtn__t', 'Compare'));
      b.addEventListener('click', function () { toggle(card, b); });
      wrap.appendChild(b);
      card.__cmp = b;
    });

    function nameOf(card) {
      var n = card.querySelector('.apg-scard__name');
      return n ? n.textContent.trim() : '';
    }
    function priceOf(card) {
      var n = boxOf(card).querySelector('.apg-scard__price');
      return n ? n.textContent.trim() : '';
    }

    function toggle(card, b) {
      var at = picked.indexOf(card);
      if (at > -1) { picked.splice(at, 1); } else {
        if (picked.length >= MAX) { picked.shift().__cmp.setAttribute('aria-pressed', 'false'); }
        picked.push(card);
        dismissed = false;
      }
      cards.forEach(function (c) {
        var on = picked.indexOf(c) > -1;
        c.__cmp.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.__cmp.innerHTML = on ? ICON_TICK : ICON_PLUS;
        c.__cmp.appendChild(el('span', 'apg-gift-cmpbtn__t', on ? 'Comparing' : 'Compare'));
      });
      render();
      giftEvent('gift_guide_comparison_updated', {
        rail_id: rail.id,
        product_handle: card.getAttribute('data-apg-handle') || '',
        selection_state: at > -1 ? 'removed' : 'added',
        selected_count: picked.length
      });
    }

    function render() {
      if (!picked.length || dismissed) {
        if (bar) { bar.remove(); bar = null; }
        return;
      }
      if (!bar) {
        bar = el('div', 'apg-gift-cmp');
        bar.setAttribute('role', 'region');
        bar.setAttribute('aria-label', 'Comparing selected gifts');
        // Appended INSIDE the scope root, not to <body>: every selector in this
        // cluster is rooted at .SCOPE and a bar on the body would be unstyled.
        root.appendChild(bar);
        if (!reduce) {
          bar.style.translate = '0 100%';
          requestAnimationFrame(function () { bar.style.translate = ''; });
        }
      }
      bar.textContent = '';
      var inner = el('div', 'apg-gift-cmp__in');

      var head = el('div', 'apg-gift-cmp__head');
      head.appendChild(el('span', 'apg-gift-cmp__ttl', 'Comparing'));
      head.appendChild(el('span', 'apg-gift-cmp__count', picked.length + ' of ' + MAX));
      var x = el('button', 'apg-gift-cmp__x');
      x.type = 'button';
      x.setAttribute('aria-label', 'Close the comparison');
      x.innerHTML = ICON_X;
      x.appendChild(el('span', 'apg-gift-cmp__xt', 'Close'));
      x.addEventListener('click', function () {
        dismissed = true;
        picked.slice().forEach(function (c) { toggle(c, c.__cmp); });
        dismissed = true;
        render();
      });
      head.appendChild(x);
      inner.appendChild(head);

      var cols = el('div', 'apg-gift-cmp__cols');
      picked.forEach(function (card) {
        var col = el('div', 'apg-gift-cmp__col');
        var top = el('div', 'apg-gift-cmp__top');
        var a = el('a', 'apg-gift-cmp__name', nameOf(card));
        a.href = card.getAttribute('href');
        top.appendChild(a);
        var drop = el('button', 'apg-gift-cmp__drop');
        drop.type = 'button';
        drop.setAttribute('aria-label', 'Remove ' + nameOf(card) + ' from the comparison');
        drop.innerHTML = ICON_X;
        drop.addEventListener('click', function () { toggle(card, card.__cmp); });
        top.appendChild(drop);
        col.appendChild(top);
        col.appendChild(el('p', 'apg-gift-cmp__price', priceOf(card)));
        [['Best fit', 'data-apg-fit'], ['Control', 'data-apg-control'], ['Power', 'data-apg-power']].forEach(function (f) {
          var row = el('p', 'apg-gift-cmp__spec');
          row.appendChild(el('span', 'apg-gift-cmp__k', f[0]));
          row.appendChild(el('span', 'apg-gift-cmp__v', card.getAttribute(f[1]) || 'Not published'));
          col.appendChild(row);
        });
        cols.appendChild(col);
      });
      inner.appendChild(cols);
      bar.appendChild(inner);
    }
  }

  /* --------------------------------------------------- the gift finder (4) */

  /**
   * Two questions, up to three products.
   *
   * The static index the server rendered is REPLACED here, not hidden: with no
   * JS it is a working, crawlable list of every gift on the page; with JS it
   * would be a redundant wall under a picker that answers the same question in
   * one gesture. Nothing on this page is ever invisible-but-present.
   *
   * Every candidate is a card the SERVER rendered into a rail, so a result can
   * never name a product a crawler cannot see, and the reason line on each is
   * the product's own curated copy off data-apg-why.
   */
  function buildFinder() {
    var f = cfg.finder;
    if (!f || !f.questions || f.questions.length < 1) return;
    var tool = root.querySelector('[data-apg-finder]');
    if (!tool) return;
    var stat = tool.querySelector('[data-apg-finder-static]');
    /* DEDUPED BY HANDLE. The finder rebuilds its candidate list from the cards
       the server already printed, and a product is legitimately allowed to sit
       on two rails — Baccarat Gold is both a warm scent and a luxury gift,
       so the oils page renders it twice on purpose. Without this, the finder
       could return the same bottle as two of its three recommendations.
       Caught by verify_gift_interactions on christmas-fragrance-oils; it never
       showed on christmas-diffuser, whose two rails are disjoint. First
       occurrence wins, which is page order and the card the reader scrolls to. */
    var all = [];
    var allSeen = {};
    [].slice.call(root.querySelectorAll('.apg-scard[data-apg-handle]')).forEach(function (c) {
      var h = c.getAttribute('data-apg-handle');
      if (h && allSeen[h]) return;
      if (h) allSeen[h] = 1;
      all.push(c);
    });
    if (!all.length) return;

    var picks = {};
    var qs = [];
    var hits = [];
    var shown = 0;
    var relaxed = null;
    // Three cards, best match first. A fourth orphans alone on its own row at
    // the widths this cluster ships at (see the .apg-gift-res__grid CSS), so
    // the cut is here, not in the CSS.
    var CARD_MAX = 3;

    var box = el('div', 'apg-gift-find');
    var progress = el('p', 'apg-gift-find__progress', f.questions.length === 1 ? 'Choose one' : 'Choose one in each');
    box.appendChild(progress);
    var mobileFinder = window.matchMedia('(max-width: 700px)');

    f.questions.forEach(function (q, qi) {
      var block = el('div', 'apg-gift-find__q');
      block.setAttribute('data-apg-find-question', String(qi));
      var head = el('div', 'apg-gift-find__qhead');
      head.appendChild(el('span', 'apg-gift-find__step', String(qi + 1)));
      head.appendChild(el('span', 'apg-gift-find__label', q.label));
      block.appendChild(head);
      var set = el('div', 'apg-gift-find__set');
      var btns = [];
      q.options.forEach(function (o, oi) {
        var b = el('button', 'apg-gift-chip apg-gift-chip--find');
        b.type = 'button';
        b.setAttribute('aria-pressed', 'false');
        b.appendChild(el('span', 'apg-gift-chip__t', o.label));
        if (o.description) b.appendChild(el('span', 'apg-gift-chip__desc', o.description));
        b.addEventListener('click', function () {
          var selected = picks[q.id] !== oi;
          picks[q.id] = selected ? oi : null;
          btns.forEach(function (x, i) { x.setAttribute('aria-pressed', picks[q.id] === i ? 'true' : 'false'); });
          answer();
        });
        set.appendChild(b);
        btns.push(b);
      });
      block.appendChild(set);
      box.appendChild(block);
      qs.push({ q: q, btns: btns, block: block });
    });

    // No class while it is empty: Dawn ships div:empty{display:none} and the
    // visual gate reads any invisible apg-* block as content that failed to
    // render. Styled through the data attribute instead.
    var out = el('div');
    out.setAttribute('data-apg-find-out', '');
    out.setAttribute('aria-live', 'polite');
    box.appendChild(out);

    tool.insertBefore(box, stat || null);
    if (stat) stat.remove();

    function syncMobileStep() {
      qs.forEach(function (x) { x.block.hidden = false; });
      progress.textContent = mobileFinder.matches
        ? (qs.length === 1 ? 'Choose one' : 'Choose one in each')
        : '';
    }

    /** One option's predicate, run against a card the server printed. */
    function matches(card, q, oi) {
      if (oi == null || oi < 0) return true;
      var o = q.options[oi];
      if (!o || !o.attr) return true;                       // an open answer ("No limit")
      var v = card.getAttribute('data-apg-' + o.attr) || '';
      if (o.mode === 'lessThan') return v !== '' && parseFloat(v) < parseFloat(o.value);
      if (o.mode === 'token') {
        var have = ' ' + v + ' ';
        return o.values.some(function (w) { return have.indexOf(' ' + w + ' ') > -1; });
      }
      return o.values.indexOf(v) > -1;
    }

    /* The recommendation order, mirroring rankGiftMatches() in gift-page.mjs:
       preferred product type, price, review count, then recipient specificity. */
    function rank(list, cheapestFirst, preferredType) {
      return list.slice().sort(function (a, b) {
        if (preferredType) {
          var type = Number(b.getAttribute('data-apg-type') === preferredType)
            - Number(a.getAttribute('data-apg-type') === preferredType);
          if (type !== 0) return type;
        }
        var pa = parseFloat(a.getAttribute('data-apg-price') || '0');
        var pb = parseFloat(b.getAttribute('data-apg-price') || '0');
        var price = cheapestFirst ? pa - pb : pb - pa;
        if (price !== 0) return price;
        var reviews = parseFloat(b.getAttribute('data-apg-reviews') || '0')
          - parseFloat(a.getAttribute('data-apg-reviews') || '0');
        if (reviews !== 0) return reviews;
        var sa = (a.getAttribute('data-apg-recipients') || '').split(' ').filter(Boolean).length;
        var sb = (b.getAttribute('data-apg-recipients') || '').split(' ').filter(Boolean).length;
        return sa - sb;
      });
    }

    function label(x) {
      var i = picks[x.q.id];
      return i == null ? '' : x.q.options[i].label;
    }

    function answer() {
      var answered = qs.filter(function (x) { return picks[x.q.id] != null; });
      if (answered.length < qs.length) {
        out.textContent = '';
        hits = [];
        return;
      }
      relaxed = null;
      var found = all.filter(function (c) {
        return qs.every(function (x) { return matches(c, x.q, picks[x.q.id]); });
      });
      var cheapest = false;
      var preferredType = (qs[0].q.options[picks[qs[0].q.id]] || {}).preferType || '';
      if (!found.length && qs.length > 1) {
        // Drop the budget before the person: a gift for the wrong person is
        // useless; slightly over budget is a decision the reader can make.
        found = all.filter(function (c) { return matches(c, qs[0].q, picks[qs[0].q.id]); });
        if (found.length) { relaxed = { dropped: label(qs[1]), kept: label(qs[0]) }; cheapest = true; }
      }
      if (!found.length && qs.length > 1) {
        found = all.filter(function (c) { return matches(c, qs[1].q, picks[qs[1].q.id]); });
        if (found.length) relaxed = { dropped: label(qs[0]), kept: label(qs[1]) };
      }
      if (!found.length) { found = all; relaxed = { dropped: qs.length > 1 ? 'both answers' : 'the selected path', kept: '' }; }
      hits = rank(found, cheapest, preferredType);
      shown = Math.min(hits.length, mobileFinder.matches ? 1 : CARD_MAX);
      show();
      syncMobileStep(qs.length);
      giftEvent('gift_guide_finder_completed', {
        answer_labels: qs.map(label).filter(Boolean).join(' | '),
        match_mode: relaxed ? 'relaxed' : 'exact',
        result_count: hits.length,
        top_product_handle: hits[0] ? hits[0].getAttribute('data-apg-handle') || '' : ''
      });
    }

    function reset() {
      picks = {};
      qs.forEach(function (x) {
        x.btns.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      });
      hits = [];
      shown = 0;
      relaxed = null;
      out.textContent = '';
      syncMobileStep(0);
      qs[0].btns[0].focus();
    }

    /**
     * One card in the result grid. i is its rank position — 0 is the best
     * match and the only one that carries the badge; the rest are ordered but
     * unlabelled, because numbering them 1/2/3 reads as a leaderboard and this
     * is a gift.
     */
    function buildResultCard(card, i) {
      var li = el('li', 'apg-gift-res' + (i === 0 ? ' apg-gift-res--best' : ''));
      var a = document.createElement('a');
      a.className = 'apg-gift-res__link';
      a.href = card.getAttribute('href');
      a.setAttribute('data-apg-result-rank', String(i + 1));

      var img = card.querySelector('.apg-scard__imgwrap img');
      var frame = null;
      if (img) {
        frame = el('div', 'apg-gift-res__art');
        var copy = document.createElement('img');
        copy.src = img.getAttribute('src');
        // Alt is empty on purpose: the whole card is one link, and its name
        // is read as text a moment later — a screen reader that also read
        // the photo's alt would say the product name twice per card.
        copy.alt = '';
        copy.setAttribute('width', '300');
        copy.setAttribute('height', '300');
        copy.setAttribute('loading', 'lazy');
        copy.setAttribute('decoding', 'async');
        frame.appendChild(copy);
        a.appendChild(frame);
      }

      if (i === 0) {
        var badge = el('span', 'apg-gift-res__badge');
        badge.insertAdjacentHTML('afterbegin', ICON_TICK);
        badge.appendChild(el('span', null, relaxed ? 'Closest match' : (f.resultLabel || 'Best match')));
        // Overlaid on the photo, not stacked above it — in normal flow the
        // badge pushed the top card's image down and threw off row
        // alignment with the other two. Falls back to the link itself on
        // the rare card with no photo.
        (frame || a).appendChild(badge);
      }

      var body = el('div', 'apg-gift-res__b');
      var h = el('p', 'apg-gift-res__name');
      h.innerHTML = card.querySelector('.apg-scard__name').innerHTML;
      body.appendChild(h);

      var pr = el('p', 'apg-gift-res__price');
      pr.innerHTML = boxOf(card).querySelector('.apg-scard__price').innerHTML;
      body.appendChild(pr);

      // The reason, from the product's own curated copy — never generated.
      var why = card.getAttribute('data-apg-why');
      if (!why) {
        var d = card.querySelector('.apg-scard__desc');
        why = d ? d.textContent.trim() : '';
      }
      if (why) body.appendChild(el('p', 'apg-gift-res__desc', why));

      var cta = el('span', 'apg-gift-res__cta');
      cta.appendChild(el('span', null, f.ctaLabel || 'See this gift'));
      cta.insertAdjacentHTML('beforeend', ICON_ARROW);
      body.appendChild(cta);

      a.appendChild(body);
      li.appendChild(a);
      return li;
    }

    function show() {
      out.textContent = '';
      if (!hits.length) return;

      var wrap = el('div', 'apg-gift-res-set');

      // What it was matched ON, stated plainly. When an answer had to be
      // dropped the line says which one, rather than quietly showing
      // something that does not fit. Kept even with multiple cards — it is
      // the one sentence that explains why THIS set of products came back.
      var picked = qs.map(label).filter(Boolean);
      wrap.appendChild(el(
        'p',
        'apg-gift-res__match',
        relaxed
          ? (relaxed.kept
            ? 'Nothing here is both “' + picked.join('” and “') + '”. Closest on “' + relaxed.kept + '”:'
            : 'Nothing here matched either answer, so here is the pick of the page:')
          : 'Matches “' + picked.join('” · “') + '”',
      ));

      var grid = el('ul', 'apg-gift-res__grid');
      grid.setAttribute('role', 'list');
      for (var i = 0; i < shown; i += 1) grid.appendChild(buildResultCard(hits[i], i));
      wrap.appendChild(grid);

      // Nobody is trapped in one answer, and with 19 matches nobody should
      // have to click a "runner-up" button eighteen times to see the rest —
      // one click reveals what is left, in place.
      var controls = el('div', 'apg-gift-res__controls');
      if (hits.length > shown) {
        var more = el('button', 'apg-gift-res__more');
        more.type = 'button';
        var moreText = el('span', null, mobileFinder.matches && shown === 1
          ? 'See ' + Math.min(CARD_MAX - 1, hits.length - 1) + ' more matches'
          : 'See all ' + hits.length + ' matches');
        more.appendChild(moreText);
        more.addEventListener('click', function () {
          var from = shown;
          shown = mobileFinder.matches && shown < CARD_MAX ? Math.min(hits.length, CARD_MAX) : hits.length;
          for (var j = from; j < shown; j += 1) {
            var extra = buildResultCard(hits[j], j);
            grid.appendChild(extra);
            restage(extra, (j - from) * 70);
          }
          if (shown < hits.length) moreText.textContent = 'See all ' + hits.length + ' matches';
          else more.remove();
        });
        controls.appendChild(more);
      }
      var again = el('button', 'apg-gift-res__alt apg-gift-res__alt--ghost');
      again.type = 'button';
      again.appendChild(el('span', 'apg-gift-res__altt', f.againLabel || 'Start again'));
      again.addEventListener('click', reset);
      controls.appendChild(again);
      wrap.appendChild(controls);

      out.appendChild(wrap);
      // Reveal now that the whole set is attached — staggering while
      // detached would skip the forced-reflow trick restage() relies on.
      [].slice.call(grid.children).forEach(function (li, i) { restage(li, i * 70); });
    }

    syncMobileStep(0);
    if (mobileFinder.addEventListener) mobileFinder.addEventListener('change', function () { syncMobileStep(0); });
  }

  /* ------------------------------------------------ sticky jump nav (6) */

  function buildJump() {
    var items = cfg.nav || [];
    if (items.length < 2) return;
    var bar = null;
    var links = [];

    function make() {
      var n = el('nav', 'apg-gift-jump');
      n.setAttribute('aria-label', 'Jump to a section');
      var inner = el('div', 'apg-gift-jump__in');
      links = items.map(function (it) {
        var a = el('a', 'apg-gift-jump__l', it.label);
        a.href = '#' + it.id;
        inner.appendChild(a);
        return a;
      });
      n.appendChild(inner);
      root.appendChild(n);
      return n;
    }

    function mark() {
      var best = -1;
      var bestTop = -1e9;
      items.forEach(function (it, i) {
        var t = document.getElementById(it.id);
        if (!t) return;
        var top = t.getBoundingClientRect().top - 120;
        if (top <= 0 && top > bestTop) { bestTop = top; best = i; }
      });
      links.forEach(function (a, i) {
        if (i === best) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
      /* On a phone the bar is narrower than its own contents, so the current
         section's chip can sit off-screen. Bring it back without moving the
         page. */
      if (best > -1 && links[best] && bar && window.innerWidth < 1024) {
        var strip = bar.firstChild;
        var l = links[best];
        var want = l.offsetLeft - 16;
        if (Math.abs(strip.scrollLeft - want) > 24) {
          if (strip.scrollTo) strip.scrollTo({ left: want, behavior: 'smooth' });
          else strip.scrollLeft = want;
        }
      }
    }

    function sync() {
      /* NO WIDTH GATE. This was innerWidth >= 1024, so the one navigation
         aid on a 13,000px page existed only for the quarter of the audience on
         a desktop. All three independent reviews of the page raised it. The
         bar has always been horizontally scrollable, so it fits a phone as it
         is — it was gated, not unbuilt. */
      var hero = root.querySelector('.apg-gift-hero') || root.querySelector('.apg-hero');
      var past = hero ? hero.getBoundingClientRect().bottom < 4 : window.scrollY > 480;
      if (past) {
        if (!bar) bar = make();
        mark();
      } else if (bar) {
        bar.remove();
        bar = null;
        links = [];
      }
    }

    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ------------------------------------------------------------- run it */

  (cfg.rails || []).forEach(function (rail) {
    buildCompare(rail);
    buildFilter(rail);
    armReveal([].slice.call(document.querySelectorAll('#' + rail.id + ' .apg-carousel__track > *')));
  });
  buildFinder();
  buildJump();
  armReveal([].slice.call(root.querySelectorAll('.apg-gift-aid__tool')));
  heroEntrance();
})();
